export const commonEn = {
  nav: {
    home: 'Home',
    about: 'About Us',
    menu: 'Menu',
    wineList: 'Wine List',
    contact: 'Contact',
    reservations: 'Book a Table',
    careers: 'Careers',
    aboutSub: {
      ourStory: 'Our Story',
      joinTeam: 'Join Our Team',
    },
    menuSub: {
      foodMenu: 'Food Menu',
      wineList: 'Wine List',
    },
    contactSub: {
      getInTouch: 'Get in Touch',
      findUs: 'Find Us',
    },
  },
  viewItem: 'View Item',
  footer: {
    about:
      'Authentic Neapolitan cuisine in the heart of Reykjavik. Fresh ingredients, traditional recipes, and the true taste of Italy.',
    social: {
      title: 'Follow Us',
    },
    hours: {
      title: 'Opening Hours',
      weekdays: 'Monday – Saturday',
      weekdaysTime: '12:00 – 22:00',
      sunday: 'Sunday',
      sundayTime: '17:00 – 22:00',
    },
    contact: {
      title: 'Contact Us',
      address: 'Laugavegi 40a, 101 Reykjavík',
      phone: '561 0500',
      email: 'larusg@simnet.is',
      hours: {
        weekdays: 'Monday - Saturday: 12:00 - 22:00',
        sunday: 'Sunday: 17:00 - 22:00',
      },
    },
    quickLinks: {
      title: 'Quick Links',
      home: 'Home',
      about: 'About Us',
      menu: 'Menu',
      wineList: 'Wine List',
      contact: 'Contact',
      careers: 'Careers',
    },
    newsletter: {
      title: 'Stay Updated',
      description: 'Subscribe to our newsletter for special offers, new menu items, and events.',
      placeholder: 'Your email address',
      button: 'Subscribe',
      subscribing: 'Subscribing...',
      success: {
        title: 'Thank you for subscribing!',
        message:
          "You'll receive updates about our special offers, new menu items, and exclusive events.",
        autoClose: 'This notification will close automatically',
      },
    },
    copyright: 'Rossopomodoro Iceland. All rights reserved.',
  },
  credit: {
    text: 'Designed & built with passion in Reykjavík by',
    company: 'Litljómi',
  },
};
